// extracted by mini-css-extract-plugin
export default {"backArrow":"styles_backArrow__aUlmp"};